import { render, staticRenderFns } from "./MyTips.vue?vue&type=template&id=0edc3a67&scoped=true"
import script from "./MyTips.vue?vue&type=script&lang=js"
export * from "./MyTips.vue?vue&type=script&lang=js"
import style0 from "./MyTips.vue?vue&type=style&index=0&id=0edc3a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc3a67",
  null
  
)

export default component.exports